import React, { Component, Fragment } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import { setAppInstance } from "./Persistence/Local";
import "./App.css";
import Player from "./Views/Player";
import Locations from "./Views/Locations";
import AddPlayer from "./Views/AddPlayer";
import RecentlyPlayed from "./Views/RecentlyPlayed";
import ChangeMusic from "./Views/ChangeMusic/ChangeMusic";
import { WS_URL, API_URL } from './Config'
import { handleErrors } from './Helpers'

let ws = new WebSocket(WS_URL);

const addDate = (obj) => {
  obj.date = new Date();
  return obj;
}

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  fetchCurrentZone(zone) {
    fetch(`${API_URL}/zone?token=${zone.token}`)
      .then(handleErrors)
      .then(response => response.json())
      .then(response => {
        console.log('fetchCurrentZone Response', response)
        this.setState({
          currentZone: zone,
          playback: response.playback,
          currentTrack: response.nowPlaying,
          recentlyPlayed: window.persistence.local.get('recentlyPlayed') || [addDate(response.nowPlaying)]
        })
      })
      .catch(error => {
        alert(`Something went wrong with current zone: ${zone.name}.\n${error}`);
        if (window.location.pathname !== "/") {
          window.location.replace('/');
        }
      })
  }

  setCurrentZone(zone) {
    window.persistence.local.set('currentZone', zone);
    this.setState({ currentZone: zone })
    this.fetchCurrentZone(zone);
    ws.close()
    if (!this.socketInitialized) {
      ws = new WebSocket(WS_URL);
      this.addSocketListeners();
    }
  }

  componentWillMount() {
    setAppInstance(this);

    const currentZone = window.persistence.local.get('currentZone');
    if (currentZone) {
      this.setState({ currentZone: currentZone });
      this.fetchCurrentZone(window.persistence.local.get('currentZone'));
    }
  }

  addSocketListeners() {
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      console.log('Socket data:', data);
      switch (data.type) {
        case 'playback':
          console.log('playback', data.playback);
          this.setState({ playback: data.playback })
          break;
        case 'soundZone':
          console.log('soundZone', data);
          this.setState({ upcoming: data.soundZone.playFrom })
          break;
        case 'nowPlaying':
          console.log('nowPlaying', data.nowPlaying);
          let recentlyPlayed = this.state.recentlyPlayed || [];
          recentlyPlayed.unshift(addDate(data.nowPlaying));
          if (recentlyPlayed.length > 10) { recentlyPlayed = recentlyPlayed.slice(0, 10); }
          this.setState({ currentTrack: data.nowPlaying, recentlyPlayed: recentlyPlayed })
          window.persistence.local.set('recentlyPlayed', recentlyPlayed);
          break;
        default:
          console.error(`${data.type} - type is not supported`)
          break;
      }
    }

    ws.onopen = () => {
      console.log('connection opened');
      if (this.state.currentZone) {
        ws.send(JSON.stringify({ 'type': 'nowPlaying', 'token': this.state.currentZone.token }));
        this.wsInterval = window.setInterval(() => { if (ws) ws.send(JSON.stringify({})) }, 30000);
      }
    }

    ws.onclose = (e) => {
      console.log('connection closed', e);
      clearInterval(this.wsInterval)
      ws = null
      setTimeout(() => {
        ws = new WebSocket(WS_URL);
        this.addSocketListeners();
      }, 1000)
    }
    ws.onerror = (e) => {
      console.log('socket error', e)
    }
    this.socketInitialized = true

  }

  componentDidMount() {
    this.addSocketListeners();
  }

  componentWillUnmount() {
    clearInterval(this.wsInterval)
    ws.onclose = null;
    ws.close();
  }

  render() {
    return (
      <Router>
        <Fragment>
          <Route path="/" exact render={(props) => <Locations {...props} setCurrentZone={(zone) => this.setCurrentZone(zone)} />} />
          <Route path="/player" render={(props) => <Player currentZone={this.state.currentZone} setCurrentZone={() => this.setCurrentZone(this.state.currentZone)} currentTrack={this.state.currentTrack} playback={this.state.playback} upcoming={this.state.upcoming} {...props} />} />
          <Route path="/add" render={(props) => <AddPlayer {...props} setCurrentZone={(zone) => this.setCurrentZone(zone)} />} />
          <Route
            path="/change-music"
            render={(props) => <ChangeMusic currentZone={this.state.currentZone} currentPlayFrom={this.state.currentTrack} {...props} />}
          />
          <Route path="/recent" render={(props) => <RecentlyPlayed {...props} songs={this.state.recentlyPlayed} />} />
        </Fragment>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js